import styled from 'styled-components';
import { ApartmentOutlined } from '@ant-design/icons';

export const ApartmentIcon = styled(ApartmentOutlined)`
  font-size: 16px;
  color: #666;
`;
